import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import { notify } from '../../../../utils/notification'
import * as req from '../../../../axios/request/SocietyController/CtrlLocationReqs/CtrlLocationReqs'


function* getCountries(action) {
    try {
        const result = yield call(req.getCountriesReq, action);
        console.log(result, 'fasdads')
        if (result.success === true) {
            notify('success', result.message);
            yield put({ type: types.CTRL_GET_COUNTRY_SUCCESS, payload: result });
        } else {
            yield put({ type: types.CTRL_GET_COUNTRY_FAILURE, message: result?.message });
        }
        yield put({ type: types.CTRL_GET_COUNTRY_FAILURE, message: 'API endpoint not configured' });
    } catch (e) {
        console.log(e)
        yield put({ type: types.CTRL_GET_COUNTRY_FAILURE, message: e?.message });
    }
}

function* getCountryDetails(action) {
    try {
        const result = yield call(req.getCountryDetailsReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({ type: types.CTRL_GET_COUNTRY_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.CTRL_GET_COUNTRY_DETAILS_FAILURE, message: result?.message });
        }
        yield put({ type: types.CTRL_GET_COUNTRY_DETAILS_FAILURE, message: 'API endpoint not configured' });
    } catch (e) {
        console.log(e)
        yield put({ type: types.CTRL_GET_COUNTRY_DETAILS_FAILURE, message: e?.message });
    }
}

function* createCountry(action) {
    try {
        const result = yield call(req.createCountryReq, action);
        console.log(result)
        if (result.success === true) {
            notify('success', result.message);
            action?.data?.onSuccess?.();
            yield put({ type: types.CTRL_CREATE_COUNTRY_SUCCESS, payload: result.data });
        } else {
            notify('success', result?.response?.data?.message);
            yield put({ type: types.CTRL_CREATE_COUNTRY_FAILURE, message: result?.message });
        }
        yield put({ type: types.CTRL_CREATE_COUNTRY_FAILURE, message: 'API endpoint not configured' });
    } catch (e) {
        console.log(e)
        yield put({ type: types.CTRL_CREATE_COUNTRY_FAILURE, message: e?.message });
    }
}

function* editCountry(action) {
    try {
        const result = yield call(req.editCountryReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({ type: types.CTRL_EDIT_COUNTRY_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.CTRL_EDIT_COUNTRY_FAILURE, message: result?.message });
        }
        yield put({ type: types.CTRL_EDIT_COUNTRY_FAILURE, message: 'API endpoint not configured' });
    } catch (e) {
        console.log(e)
        yield put({ type: types.CTRL_EDIT_COUNTRY_FAILURE, message: e?.message });
    }
}

function* deleteCountry(action) {
    try {
        const result = yield call(req.deleteCountryReq, action);
        if (result.success === true) {
            console.log(result)
            notify('success', result.message);
            action?.data?.onSuccess();
            yield put({ type: types.CTRL_DELETE_COUNTRY_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.CTRL_DELETE_COUNTRY_FAILURE, message: result?.message });
        }
        yield put({ type: types.CTRL_DELETE_COUNTRY_FAILURE, message: 'API endpoint not configured' });
    } catch (e) {
        console.log(e)
        yield put({ type: types.CTRL_DELETE_COUNTRY_FAILURE, message: e?.message });
    }
}


function* getStates(action) {
    try {
        const result = yield call(req.getStatesReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({ type: types.CTRL_GET_STATE_SUCCESS, payload: result });
        } else {
            yield put({ type: types.CTRL_GET_STATE_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CTRL_GET_STATE_FAILURE, message: e?.message });
    }
}

function* getStateDetails(action) {
    try {
        const result = yield call(req.getStateDetailsReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({ type: types.CTRL_GET_STATE_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.CTRL_GET_STATE_DETAILS_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CTRL_GET_STATE_DETAILS_FAILURE, message: e?.message });
    }
}

function* createState(action) {
    try {
        const result = yield call(req.createStateReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({ type: types.CTRL_CREATE_STATE_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.CTRL_CREATE_STATE_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CTRL_CREATE_STATE_FAILURE, message: e?.message });
    }
}

function* editState(action) {
    try {
        const result = yield call(req.editStateReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({ type: types.CTRL_EDIT_STATE_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.CTRL_EDIT_STATE_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CTRL_EDIT_STATE_FAILURE, message: e?.message });
    }
}

function* deleteState(action) {
    try {
        const result = yield call(req.deleteStateReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({ type: types.CTRL_DELETE_STATE_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.CTRL_DELETE_STATE_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CTRL_DELETE_STATE_FAILURE, message: e?.message });
    }
}


/* =========================
   GET CITIES
========================= */
function* getCities(action) {
    try {
        const result = yield call(req.getCitiesReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({ type: types.CTRL_GET_CITY_SUCCESS, payload: result });
        } else {
            yield put({ type: types.CTRL_GET_CITY_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e);
        yield put({ type: types.CTRL_GET_CITY_FAILURE, message: e?.message });
    }
}

/* =========================
   GET CITY DETAILS
========================= */
function* getCityDetails(action) {
    try {
        const result = yield call(req.getCityDetailsReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({
                type: types.CTRL_GET_CITY_DETAILS_SUCCESS,
                payload: result.data
            });
        } else {
            yield put({
                type: types.CTRL_GET_CITY_DETAILS_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.CTRL_GET_CITY_DETAILS_FAILURE,
            message: e?.message
        });
    }
}

/* =========================
   CREATE CITY
========================= */
function* createCity(action) {
    try {
        const result = yield call(req.createCityReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({
                type: types.CTRL_CREATE_CITY_SUCCESS,
                payload: result.data
            });
            action?.data?.onSuccess?.();
        } else {
            yield put({
                type: types.CTRL_CREATE_CITY_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.CTRL_CREATE_CITY_FAILURE,
            message: e?.message
        });
    }
}

/* =========================
   EDIT CITY
========================= */
function* editCity(action) {
    try {
        const result = yield call(req.editCityReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({
                type: types.CTRL_EDIT_CITY_SUCCESS,
                payload: result.data
            });
            action?.data?.onSuccess?.();
        } else {
            notify('error', result.response?.data?.message || result.message);
            yield put({
                type: types.CTRL_EDIT_CITY_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.CTRL_EDIT_CITY_FAILURE,
            message: e?.message
        });
    }
}

/* =========================
   DELETE CITY
========================= */
function* deleteCity(action) {
    try {
        const result = yield call(req.deleteCityReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({
                type: types.CTRL_DELETE_CITY_SUCCESS,
                payload: result.data
            });
            action?.data?.onSuccess?.();
        } else {
            yield put({
                type: types.CTRL_DELETE_CITY_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.CTRL_DELETE_CITY_FAILURE,
            message: e?.message
        });
    }
}
export default function* ctrlCountrySaga() {
    yield takeLatest(types.CTRL_GET_COUNTRY, getCountries);
    yield takeLatest(types.CTRL_GET_COUNTRY_DETAILS, getCountryDetails);
    yield takeLatest(types.CTRL_CREATE_COUNTRY, createCountry);
    yield takeLatest(types.CTRL_EDIT_COUNTRY, editCountry);
    yield takeLatest(types.CTRL_DELETE_COUNTRY, deleteCountry);

    yield takeLatest(types.CTRL_GET_STATE, getStates);
    yield takeLatest(types.CTRL_GET_STATE_DETAILS, getStateDetails);
    yield takeLatest(types.CTRL_CREATE_STATE, createState);
    yield takeLatest(types.CTRL_EDIT_STATE, editState);
    yield takeLatest(types.CTRL_DELETE_STATE, deleteState);

    yield takeLatest(types.CTRL_GET_CITY, getCities);
    yield takeLatest(types.CTRL_GET_CITY_DETAILS, getCityDetails);
    yield takeLatest(types.CTRL_CREATE_CITY, createCity);
    yield takeLatest(types.CTRL_EDIT_CITY, editCity);
    yield takeLatest(types.CTRL_DELETE_CITY, deleteCity);

}
